export default __webpack_public_path__ + "static/media/Minecraft.81f6c7f8.ttf";